document.addEventListener("DOMContentLoaded", function () {

	// Function to adjust font sizes
	const largeTexts = document.querySelectorAll(".dynamic-font");
	if (largeTexts.length > 0) {
		function adjustFontSizes () {

			largeTexts.forEach(text => {
				// Reset font size to max before recalculating
				text.style.fontSize = "72px";
				let maxFontSize = 72;
				let minFontSize = 20;

				if (window.innerWidth < 1024) {
					text.style.fontSize = "56px";
					const maxFontSize = 56;
				}

				let fontSize = maxFontSize;

				// Reduce font size until the text fits or reaches the minimum font size
				while (text.scrollWidth > text.clientWidth && fontSize > minFontSize) {
					fontSize -= 1;
					text.style.fontSize = fontSize + "px";
				}

				// Ensure font size doesn't go below the minimum
				if (fontSize < minFontSize) {
					text.style.fontSize = minFontSize + "px";
				}
			});
		}

		adjustFontSizes();
		window.addEventListener("resize", adjustFontSizes);
	}

});
